import * as moment from 'moment';
import { ApplicationUserViewModel, ITrackableViewModel, TrackableObjectBase } from '../../models';
import { wideService } from '../../common/constants';

import { getDefaultUser } from './getDefaultUser';

export function getTrackable(users: ApplicationUserViewModel[], item: TrackableObjectBase, defaultUserName: string) {
    const trackable = {} as ITrackableViewModel;
    if (item && users && users.length > 0) {
        setCreatedBy(item, trackable, users, defaultUserName);
        setModifiedBy(item, trackable, users, defaultUserName);
        if (item.creationDate) {
            trackable.createdOn = moment(item.creationDate).toISOString();
        }
        if (item.lastModificationDate) {
            trackable.modifiedOn = moment(item.lastModificationDate).toISOString();
        }
        if (!trackable.displayUser) {
            trackable.displayUser = getDefaultUser(item, false, defaultUserName);
        }
    }
    return trackable;
}

function setModifiedBy(item: TrackableObjectBase, trackable: ITrackableViewModel, users: ApplicationUserViewModel[], defaultUserName: string) {
    if (item.lastModifier) {
        trackable.modifiedBy = users.find(user => user.name === item.lastModifier);
        if (trackable.modifiedBy) {
            trackable.displayUser = trackable.modifiedBy;
        }
        if (!trackable.modifiedBy) {
            trackable.modifiedBy = getDefaultUser(item, false, defaultUserName);
        }
    }
}

function setCreatedBy(item: TrackableObjectBase, trackable: ITrackableViewModel, users: ApplicationUserViewModel[], defaultUserName: string) {
    if (item.creationUser) {
        if (item.creationUser !== wideService) {
            trackable.createdBy = users.find(user => user.name === item.creationUser);
        }
        if (!trackable.displayUser && trackable.createdBy) {
            trackable.displayUser = trackable.createdBy;
        }
        if (!trackable.createdBy) {
            trackable.createdBy = getDefaultUser(item, true, defaultUserName);
        }
    }
}
